import { cn } from "@/utils/cn";
import { NavLink, useLocation } from "react-router-dom";

const SubMenuButton: React.FC<{
  route: string;
  children: React.ReactNode;
}> = ({ children, route }) => {
  const { pathname } = useLocation();
  const active = pathname.startsWith(route);
  return (
    <NavLink
      to={route}
      className={cn(
        "py-2 px-4 rounded-full bg-gradient-to-r from-black/50 to-black/0 text-white",
        active && "font-bold"
      )}
    >
      {children}
    </NavLink>
  );
};

export default SubMenuButton;
